<template>
    <!-- 三个选项的导图样式 -->
    <div v-if="mindDataNum === 4" class="mind">
        <img
            v-if="!isCanPlayAudio"
            src="https://i.gsxcdn.com/2274080577_ggn54um8.png"
            class="play-btn"
            @click="handleClickPlayBtn"
        >

        <div class="qbody">
            <div class="img-box">
                <img class="img" :src="mindData[0].image" alt="">
            </div>
            <div class="txt">
                {{mindData[0].txt}}
            </div>
        </div>
        <Transition
            name="fade"
            v-for="(item, index) in selectionData"
            :key="index"
        >
            <div v-if="item.show" :class="['qselect', `qselect${index + 1}`]">
                <div class="img-box">
                    <img class="img" :src="item.image" alt="">
                </div>
                <div class="txt">
                    {{item.txt}}
                </div>
            </div>
        </Transition>
        <Transition
            name="fadeshow"
            v-show="item.show"
            v-for="(item, index) in selectionData"
            :key="index"
        >
            <div :class="['line', `line${index + 1}`]"></div>
        </Transition>
    </div>
    <!-- 四个选项的导图样式 -->
    <div v-else-if="mindDataNum === 5" class="mind">
        <img
            v-if="!isCanPlayAudio"
            src="https://i.gsxcdn.com/2274080577_ggn54um8.png"
            class="play-btn"
            @click="handleClickPlayBtn"
        >
        <div class="qbody">
            <div class="img-box">
                <img class="img" :src="mindData[0].image" alt="">
            </div>
            <div class="txt">
                {{mindData[0].txt}}
            </div>
        </div>
        <Transition
            name="fade"
            v-for="(item, index) in selectionData"
            :key="index"
        >
            <div v-if="item.show" :class="['qselect', `qselect${index + 4}`]">
                <div class="img-box">
                    <img class="img" :src="item.image" alt="">
                </div>
                <div class="txt">
                    {{item.txt}}
                </div>
            </div>
        </Transition>
        <Transition
            name="fadeshow"
            v-show="item.show"
            v-for="(item, index) in selectionData"
            :key="index"
        >
            <div :class="['line', `line${index + 4}`]"></div>
        </Transition>
    </div>
</template>
<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    created() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        // 选项数组
        selectionData() {
            const {opusInfo} = this.pageData.opusHistoryInfo;
            opusInfo.forEach(item => {
                item.show = true;
            });
            return opusInfo.slice(1, opusInfo.length);
        },
        // 包含题干和选项的思维导图题目完整数据
        mindData() {
            const {opusInfo} = this.pageData.opusHistoryInfo;
            return opusInfo;
        },
        mindDataNum() {
            return this.mindData.length;
        }
    },
    unmounted() {
        this.audioel?.pause();
    },
})
export default class Single extends Vue {
    // 用户是否点击了播放按钮
    isCanPlayAudio = false;
    // 当前导图题的索引
    currentIndex = 0;
    audioel = null;

    // 点击播放按钮
    handleClickPlayBtn() {
        // 捕获是否有正在播放的视频，有的话全部停掉
        const allVideos = document.querySelectorAll('.oss-work-video');
        const arr = [...allVideos];
        arr.forEach(item => {
            item.pause();
        });

        this.isCanPlayAudio = true;
        // 将选项全部隐藏
        this.selectionData.forEach(item => {
            item.show = false;
        });
        // 播放题目语音
        this.playTiganAudio();
    }

    // 播放选项音频
    playTiganAudio() {
        const {mindData, selectionData, currentIndex} = this;
        const {voiceResult, url, audio} = currentIndex === 0 ? mindData[currentIndex] : selectionData[currentIndex - 1];
        this.playAudio(Number(voiceResult) < 60 ? audio : url).then(() => {
            // 看下是否是最后一个了
            if (this.currentIndex + 1 === this.mindDataNum) {
                this.isCanPlayAudio = false;
                this.currentIndex = 0;
                this.selectionData.forEach(item => {
                    item.show = true;
                });
                return;
            }

            // 线出现-》选项气泡出现-》继续播放对应的选项语音
            this.currentIndex += 1;
            this.selectionData[this.currentIndex - 1].show = true;
            // 在播放用户语音
            this.playTiganAudio();
        });
    }

    // 播放语音
    playAudio(url) {
        console.log(' ------ playAudio ------', url);
        // 播放语音
        return new Promise(resolve => {
            if (!url) {
                resolve();
            }
            if (!this.audioEl) {
                const audio = new Audio();
                audio.onabort = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onabort',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onabort ${url}`);
                };
                audio.onwaiting = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onwaiting',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onwaiting ${url}`);
                };
                this.audioEl = audio;
            }
            this.audioEl.src = url;
            this.audioEl.currentTime = 0;
            this.audioEl.load();
            this.audioEl.onended = () => {
                console.log('playAudio onended', url);
                resolve();
            };
            this.audioEl.onpause = () => {
                console.log('playAudio onpause', url);
                resolve();
            };
            this.audioEl.onerror = error => {
                console.log(
                    JSON.stringify({
                        content: 'playAudio onerror',
                        audioUrl: url,
                        error: this.audioEl.error?.message,
                    })
                );
                console.log('playAudio onerror', url);
                console.log(this.audioEl.error?.message);
                resolve(error);
            };
            this.audioEl.play();
        });
    }
}
</script>

<style lang="scss" scoped>
.mind {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 1.33rem;
    width: 7.23rem;
    height: 4.05rem;
    background: url('https://g.gsxcdn.com/2237681099_9xpk6o6h.png') 0 0 no-repeat;
    background-size: 100% 100%;

    .play-btn {
        width: 1.39rem;
        height: 1.39rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
    }

    .qbody {
        position: absolute;
        top: .4rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        display: flex;
        justify-content: center;

        .img-box {
            box-shadow: inset 0 0 .03rem 0 rgba(240,74,58,.1);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: .06rem solid #fff;

            .img {
                width: 1.63rem;
                height: 1.63rem;
                border-radius: 50%;
            }
        }
        .txt {
            padding: .15rem .25rem;
            background: #FFFCF9;
            box-shadow: 0 .03rem .08rem 0 rgba(153,153,153,.09), inset 0 -.03rem .03rem 0 rgba(240,74,58,.1);
            border-radius: .42rem;
            font-size: .26rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #36485D;
            position: absolute;
            bottom: -.23rem;
            // width: 1.5rem;
            text-align: center;
        }
    }

    .qselect {
        width: 1.23rem;
        height: 1.47rem;
        position: absolute;
        z-index: 1;
        display: flex;
        justify-content: center;

        .img-box {
            width: 1.2rem;
            height: 1.2rem;
            background: #FFFCF9;
            box-shadow: inset 0 0 .03rem 0 rgba(240,74,58,.1);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            .img {
                width: 1.1rem;
                height: 1.1rem;
                border-radius: 50%;
            }
        }
        .txt {
            padding: .1rem .2rem;
            background: #FFFCF9;
            box-shadow: 0 .03rem .08rem 0 rgba(153,153,153,.09), inset 0 -.03rem .03rem 0 rgba(240,74,58,.1);
            border-radius: .42rem;
            font-size: .24rem;
            line-height: .24rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #36485D;
            position: absolute;
            bottom: .1rem;
        }
    }

    .qselect1 {
        top: .1rem;
        right: .72rem;
    }

    .qselect2 {
        bottom: .1rem;
        left: 50%;
        transform: translateX(-50%);
    }

    .qselect3 {
        top: .1rem;
        left: .75rem;
    }

    .line {
        position: absolute;
        height: .05rem;
        background-color: #00DB5F;
    }

    .line1 {
        width: 1.05rem;
        top: 1rem;
        right: 1.8rem;
        transform: rotate(-15deg);
    }

    .line2 {
        width: .5rem;
        top: 2.5rem;
        left: 50%;
        transform: translateX(-50%) rotate(90deg);
    }

    .line3 {
        width: 1.05rem;
        top: 1rem;
        left: 1.8rem;
        transform: rotate(15deg);
    }

    .qselect4 {
        top: .1rem;
        right: .72rem;
    }

    .qselect5 {
        bottom: .2rem;
        right: 1.28rem;
    }

    .qselect6 {
        bottom: .2rem;
        left: 1.31rem;
    }

    .qselect7 {
        top: .1rem;
        left: .75rem;
    }

    .line4 {
        width: 2.05rem;
        top: 1rem;
        right: 1.87rem;
        transform: rotate(-20deg);
    }

    .line5 {
        width: 2rem;
        bottom: 1.8rem;
        right: 1.7rem;
        transform: rotate(40deg);
    }

    .line6 {
        width: 2rem;
        bottom: 1.8rem;
        left: 1.7rem;
        transform: rotate(-40deg);
    }

    .line7 {
        width: 2.05rem;
        top: 1rem;
        left: 1.87rem;
        transform: rotate(20deg);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
}
</style>
